export default "__VITE_ASSET__D6HdoPh4__"